import React, { CSSProperties } from "react";
import * as flags from "./flags";

export type FlagNameType = keyof typeof flags;

const styles: CSSProperties = {
  display: "inline-block",
  height: 26,
  width: 26,
  objectFit: "cover",
  borderRadius: 100,
  marginRight: 10,
  verticalAlign: "text-bottom",
  overflow: "hidden",
  background: "#dddddd",
};

export const FlagIcon: React.FC<{ code: string }> = ({ code }) => {
  if (!code || !flags[code as FlagNameType]) return <div style={styles} />;

  const SvgComponent = flags[code as FlagNameType];

  return (
    <div style={styles}>
      <SvgComponent />
    </div>
  );
};
